module.exports = __webpack_public_path__ + "img/collection-engagementRingsHalo@2x.ddd9d4b.webp";